import {DialogChoice, DialogNode} from "@/types";
import V2EndingNodes from "@/config/NPCConfigs/v2/V2EndingNodes";

//TODo bikin supaya kalau cuma ada satu choice masih bisa lanjut

const badEndingChoices:DialogChoice[] = [
  {
    text: 'Maaf, aku sudah tidak memiliki penjelasan lain.',
    nextDialogId: 'bad_ending_elsa_a1',
    requirements : {
      minRequiredValue : [{key : "false_arguments", value : 3}]
    },
  },
  {
    text: 'Setelah aku pikir, memang Elsa pelakunya.',
    nextDialogId: 'bad_ending_elsa_a1',
    requirements : {
      minRequiredValue : [{key : "false_arguments", value : 3}]
    },
  },
]

const bungaBlamedBadEnding: { [id: string]: DialogNode } = {
  bad_ending_bunga_1: {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Yan! Tolong aku!`,
    characterImage: '/assets/character/v2/bunga_p.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_bunga_2",
  },
  bad_ending_bunga_2: {
    id: 'ending_1',
    speaker: '',
    text: `Jangan biarkan dia lari!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_bunga_3",
  },
  bad_ending_bunga_3: {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Tolong!!! Tolong Aku!!`,
    characterImage: '/assets/character/v2/bunga_p.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_bunga_3a",
  },
  bad_ending_bunga_3a: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    nextDialogId: "bwe_1",
    fade : true,
    autoplay : 1,
  },
  ...V2EndingNodes.BUNGA_WRONG_ENDING
}

const elsaBlamedBadEnding: { [id: string]: DialogNode } = {
  bad_ending_elsa_a1: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Yan....`,
    characterImage: '/assets/character/v2/elsa_p.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_elsa_a2",
    bpm : 5
  },
  bad_ending_elsa_a2: {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Maafkan aku, Elsa`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_elsa_a3",
  },
  bad_ending_elsa_a3: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Maafkan aku Yan, Elsa. Saya juga tidak melihat cara lain.`,
    characterImage: '/assets/character/v2/darius_sy.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_elsa_a4",
  },
  bad_ending_elsa_a4: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Sampai terbukti bersalah, Elsa harus di tahan di desa.`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_elsa_a5",
  },
  bad_ending_elsa_a5: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Itu tidak cukup!`,
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_elsa_a6",
  },
  bad_ending_elsa_a6: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Dia terlalu berbahaya!`,
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_elsa_a7",
  },
  bad_ending_elsa_a7: {
    id: 'ending_1',
    speaker: '',
    text: `Tangkap dia!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_elsa_a8",
  },
  bad_ending_elsa_a8: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Yan! Tolong!`,
    characterImage: '/assets/character/v2/elsa_c.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_elsa_a9",
  },
  bad_ending_elsa_a9: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Hentikan!`,
    characterImage: '/assets/character/v2/darius_a.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_elsa_a10",
  },
  bad_ending_elsa_a10: {
    id: 'ending_1',
    speaker: '',
    text: `Jangan ikut campur! Ini demi kedamaian kita semua!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_elsa_a11",
  },
  bad_ending_elsa_a11: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Tolong aku!!!`,
    characterImage: '/assets/character/v2/elsa_c.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_elsa_a12",
  },
  bad_ending_elsa_a12: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      {
        text: 'Selamatkan Elsa',
        nextDialogId: 'bad_ending_elsa_a13',
      },
    ],
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId : "elsa_2",
  },
  bad_ending_elsa_a13: {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Lepaskan Elsa!!!`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_elsa_a14",
  },
  bad_ending_elsa_a14: {
    id: 'ending_1',
    speaker: '',
    text: `Jangan ganggu kami!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_elsa_a15",
    autoplay : 3
  },
  bad_ending_elsa_a15: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    nextDialogId: "efed_1",
    autoplay : 3
  },
  ...V2EndingNodes.ELSA_FAIL_DEFEND_ENDING
}

const yanBlamedBadEnding: { [id: string]: DialogNode } = {
  yanBlamedBadEnding_1 : {
    id: 'ending_1',
    speaker : "",
    text: 'Sepertinya Yan hanya memutar fakta dari tadi!',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId : "yanBlamedBadEnding_2",
  },
  yanBlamedBadEnding_2 : {
    id: 'ending_1',
    speaker : "",
    text: 'Dia mau mempermainkan kita!',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId : "yanBlamedBadEnding_3",
  },
  yanBlamedBadEnding_3 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Kamu kira kamu bisa membuat kita saling menyalahkan!',
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId : "yanBlamedBadEnding_4",
  },
  yanBlamedBadEnding_4 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Kamu mencoba menyalahkan orang lain agar kamu tidak dituduh!',
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId : "yanBlamedBadEnding_5",
  },
  yanBlamedBadEnding_5 : {
    id: 'ending_1',
    speaker : "",
    text: 'Tangkap dia!',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId : "bad_ending_yan_1",
  },
  bad_ending_yan_1: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Semua, harap tenang!`,
    characterImage: '/assets/character/v2/darius_a.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_yan_2",
  },
  bad_ending_yan_2: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Mundur Romo! Situasi ini berbahaya!`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_yan_3",
  },
  bad_ending_yan_3: {
    id: 'ending_1',
    speaker: '',
    text: `Tangkap dia! Jangan biarkan dia kabur!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_yan_4",
  },
  bad_ending_yan_4: {
    id: 'ending_1',
    speaker: '',
    text: `Bawa dia kesitu!`,
    backgroundImage: '/assets/backdrop/stake_empty.ktx2',
    nextDialogId: "bad_ending_yan_5",
  },
  bad_ending_yan_5: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    nextDialogId: "secret_1",
    autoplay : 3
  },
  ...V2EndingNodes.SELF_DEATH_ENDING
}

let holgaBlamedBadEnding: { [id: string]: DialogNode } = {
  bad_ending_holga_1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `....`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_2",
  },
  bad_ending_holga_2: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Apakah itu benar Holga?`,
    characterImage: '/assets/character/v2/darius_sy.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_3",
  },
  bad_ending_holga_3: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Jawab Holga! Apa yang sedang kamu lakukan!`,
    characterImage: '/assets/character/v2/ato_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_4",
  },
  bad_ending_holga_4: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Aku tidak tahu apa yang sedang dia katakan!`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_5",
  },
  bad_ending_holga_5: {
    id: 'ending_1',
    speaker: 'Holga',
    text: ``,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    choices: [
      {
        text: 'Bu Holga pasti membunuh Diana, untuk membalas dendam!',
        nextDialogId: 'bad_ending_holga_a1',//todo hide if not spott morning
      },
      {
        text: 'Apakah Bu Holga membunuh Diana agar desa memfitnah Elsa?',
        nextDialogId: 'bad_ending_holga_a1',//todo hide if not spott morning
      },
      {
        text: 'Bu Holga, apa yang ibu sedang lakukan disitu?',
        nextDialogId: 'bad_ending_holga_b1',//tODO only if spoted morning
      },
      {
        text: 'Aku melihat Holga, di pagi itu, dengan mataku sendiri!',
        nextDialogId: 'bad_ending_holga_a1',//tODO only if spoted morning
      },
    ],
    nextDialogId: "bad_ending_elsa_a2",
  },

  bad_ending_holga_a1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Tidak, aku tidak melakukan itu!`,
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_a2",
  },
  bad_ending_holga_a2: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Aku tidak tahu apa yang kamu bicarakan!`,
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_a4",
  },
  bad_ending_holga_a4: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Kamu gila jika kamu menuduh aku membunuh anak orang!`,
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_d1",
  },
  bad_ending_holga_d1: {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Teganya kamu, memfitnah orang lain`,
    characterImage: '/assets/character/v2/bunga_sy.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_d2",
  },
  bad_ending_holga_d2: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Menyebabkan penderitaan bagi kita semua`,
    characterImage: '/assets/character/v2/elsa_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_d3",
  },
  bad_ending_holga_d3: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Pantas saja dia langsung cepat sekali menyalahkan aku..`,
    characterImage: '/assets/character/v2/elsa_sys.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_d4",
  },
  bad_ending_holga_d4: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Sulit dipercaya... kenapa kamu melakukan ini Holga?`,
    characterImage: '/assets/character/v2/ato_sy.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_d5",
  },
  bad_ending_holga_d5: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Ini semua omong kosong! tidak masuk akal!`,
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_d6",
  },
  bad_ending_holga_d6: {
    id: 'ending_1',
    speaker: '',
    text: `Jangan biarkan dia kabur! Tangkap dia!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_holga_d7",
  },
  bad_ending_holga_d7: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Semuanya, harap tenang!`,
    characterImage: '/assets/character/v2/darius_a.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_holga_d8",
  },
  bad_ending_holga_d8: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: ``,
    characterImage: '/assets/character/v2/darius_a.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    choices: [
      {
        text: 'Sudah cukup jangan menggunakan kekerasan!',
        nextDialogId: 'bad_ending_holga_d9',
      },
      {
        text: 'Holga harus dihukum! Dia berbahaya!',
        nextDialogId: 'bad_ending_holga_d9',
      },
    ],
    nextDialogId: "bad_ending_elsa_a2",
  },
  bad_ending_holga_d9: {
    id: 'ending_1',
    speaker: '',
    text: `Maju!!!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_holga_d10",
  },
  bad_ending_holga_d10: {
    id: 'ending_1',
    speaker: '',
    text: `Serang dia!!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "bad_ending_holga_d11",
  },
  bad_ending_holga_d11: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Tolong!!! Tolong Aku!!`,
    characterImage: '/assets/character/v2/holga_s.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId: "bad_ending_holga_d12a",
  },
  bad_ending_holga_d12a: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    nextDialogId: "hwe_1",
    fade : true,
    autoplay : 3,
  },
  ...V2EndingNodes.HOLGA_WRONG_ENDING
}

const endingPart1: { [id: string]: DialogNode } = {
  ...elsaBlamedBadEnding,
  ending_1: {
    id: 'ending_1',
    fade : true,
    speaker: 'Romo Darius',
    text: `Yan. Orang-orang desa butuh kebenaran`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_2",
  },
  ending_2: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Tetapi sepertinya semua bukti merujuk ke teman mu yang bersalah`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_3",
  },
  ending_3: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Apakah kamu memiliki bukti, bahwa bukan Elsa yang melakukan semua ini?`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_5",
  },
  ending_5: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Tidak mungkin! Di kedua kematian Elsa selalu yang terdekat dengan korban.`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_6",
  },
  ending_6: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Holga, mari kita berikan Elsa dan Yan untuk memberikan penjelasan mereka.`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_7",
  },
  ending_7: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Elsa, bisa kamu jelaskan sekali lagi kronologis dimana kamu menemukan Sondakh?`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_8",
  },
  ending_8: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Saya sedang bersama Diana dan Bunga, kita bereempat ingin berendam di Danau`,
    characterImage: '/assets/character/v2/elsa_s.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_9",
  },
  ending_9: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Lalu aku dan Diana kembali ke desa karena Yan tidak kunjung datang.`,
    characterImage: '/assets/character/v2/elsa_s.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_10",
  },
  ending_10: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Dijalan pulang, aku menemukan Sondakh.`,
    characterImage: '/assets/character/v2/elsa_sys.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_11",
  },
  ending_11: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Karena panik, aku ke desa untuk mencari bantuan orang lain.`,
    characterImage: '/assets/character/v2/elsa_sys.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_12",
  },
  ending_12: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Kenapa kita harus mempercayai cerita Elsa?`,
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_1",
  },
  ending_choice_1: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      ...badEndingChoices,
      {
        text: 'Karena Diana sedang bersama Elsa',
        nextDialogId: 'ending_a1',
        requirements : {
          hideOnstates : ["ARGUMENT_DIANA_WITH_ELSA_CHOSEN"]
        },
        storyActions : [
          { type: 'addState', value: "ARGUMENT_DIANA_WITH_ELSA_CHOSEN" },
          { type: 'addCustomValue', value: {key : "false_arguments", value : 1} },
        ],
      },
      {
        text: 'Karena Bunga melihat semua kejadian ini berlangsung',
        nextDialogId: 'ending_b1',
        requirements : {
          hideOnstates : ["ARGUMENT_BUNGA_SAW_EVERYTHING"]
        },
        storyActions : [
          { type: 'addState', value: "ARGUMENT_BUNGA_SAW_EVERYTHING" },
          { type: 'addCustomValue', value: {key : "false_arguments", value : 1} },
        ],
      },
      {
        text: 'Sondakh sudah berjam-jam mati dan baru ditemukan oleh Elsa dan Diana',
        nextDialogId: 'ending_c1',
        requirements : {
          hideOnstates : ["ARGUMENT_DEAD_HOURS_AGO"]
        },
        storyActions : [
          { type: 'addState', value: "ARGUMENT_DEAD_HOURS_AGO" },
          { type: 'addCustomValue', value: {key : "false_arguments", value : 1} },
        ],
      },
      {
        text: 'Bisa saja Sondakh dibunuh di tempat lain dan dibuang ke Danau',
        nextDialogId: 'ending_d1',
      },
    ],
    characterImage: '/assets/character/v2/holga_a.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "elsa_2",
  },
  ending_a1: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Betul sekali, aku sedang bersama Diana.`,
    characterImage: '/assets/character/v2/elsa.png',//TODO expression until here
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_a2",
  },
  ending_a2: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Diana sudah tidak ada, kamu tidak bisa membuktikan ini!`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_a3",
  },
  ending_a3: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Yan, apakah kamu memiliki bukti lain?`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_1",
  },
  ending_b1: {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Eh?`,
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_b2",
  },
  ending_b2: {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Aku tidak melihat apa-apa terjadi?`,
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_b3",
  },
  ending_b3: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Kamu jangan mengada-ngada, ini masalah serius!`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_1",
  },
  ending_c1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Itu tidak benar. Terakhir kali aku melihat Sondakh 1 jam sebelum dia ditemukan mati!`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_c2",
  },
  ending_c2: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Yan, kamu harus memiliki bukti yang kuat.`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_1",
  },
  ending_d1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Apakah itu benar? Bukti apa yang kamu punya?`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2",
  },
  ending_choice_2: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      {
        text: 'Kondisi Badan Sondakh yang basah',
        nextDialogId: 'ending_e1',
      },
      {
        text: 'Darah yang ada disekitar Danau',
        nextDialogId: 'ending_g1',
      },
      {
        text: 'Sobekan baju Sondakh',
        nextDialogId: 'ending_n1',
        //TODO only if ketemu kain
      },
    ],
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "elsa_2",
  },
  ending_e1: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Betul sekali, saya pun ingat kondisi badan mayat sangat basah`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_e2",
  },
  ending_e2: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Sangat masuk akal mayat tersebut basah karena telah hanyut untuk waktu lama di Danau.`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_g3",
  },
  ending_g1: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Memang betul, darah Sondakh tidak hanya ada di pinggir danau dan daratan`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_g3",
  },
  ending_g2: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Kita bisa melihat darah Sondakh datang dari tengah danau`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2a",
  },
  ending_g3: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Lantas, menurut kamu datang dari mana mayat Sondakh?`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2a",
  },
  ending_choice_2a: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      ...badEndingChoices,
      {
        text: 'Barat Laut, dari dekat pemukiman',
        nextDialogId: 'ending_h1',
      },
      {
        requirements : {
          hideOnstates : ["ARGUMENT_TIMUR_CHOSEN"]
        },
        storyActions : [
          { type: 'addState', value: "ARGUMENT_TIMUR_CHOSEN" },
          { type: 'addCustomValue', value: {key : "false_arguments", value : 1} },
        ],
        text: 'Timur, kearah hutan',
        nextDialogId: 'ending_i1',
      },
      {
        requirements : {
          hideOnstates : ["ARGUMENT_UTARA_CHOSEN"]
        },
        storyActions : [
          { type: 'addState', value: "ARGUMENT_UTARA_CHOSEN" },
          { type: 'addCustomValue', value: {key : "false_arguments", value : 1} },
        ],
        text: 'Dari sisi utara danau, dekat dermaga',
        nextDialogId: 'ending_i1'
      },
    ],
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "elsa_2",
  },
  ending_h1: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Daerah itu memang sepi dan jarang dilewati.`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_h2",
  },
  ending_h2: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Tapi bagaimana pembunuh itu kabur dari situ?`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_h3",
  },
  ending_h3: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Jika mengitari danau, pasti akan melewati kita semua.`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2c",
  },
  ending_h4: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Yan, pasti ada penjelasan kan?`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2b",
  },
  ending_i1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Saya rasa tidak mungkin itu terjadi. Saya ada di sekitar dermaga sebelum Sondakh ditemukan.`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_i2",
  },
  ending_i2: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Pasti saya bisa melihat jika ada yang melewati arah itu`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_i3",
  },
  ending_i3: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Aku juga setuju Yan. Aku dan Diana juga melewati jalan itu, dan tidak ada yang melewati.`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_i4",
  },
  ending_i4: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Maaf anak muda, jangan menebak-nebak`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2a",
  },
  ending_choice_2b: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      ...badEndingChoices,
      {
        text: 'Pembunuh adalah salah satu dari kita yang ada disini',
        nextDialogId: 'ending_j1',
        ///TODO if kebanyakan salah uda gamuncul
        //TODO add satate ARGUMENT_ONE_OF_US_CHOSEN
      },
      {
        text: 'Pembunuh berenang ke arah dermaga',
        nextDialogId: 'ending_k1',
        ///TODO if kebanyakan salah uda gamuncul
        //TODO add satate ARGUMENT_SWIMMING_ESCAPE_CHOSEN
      },
      {
        text: 'Pembunuh kabur kembali ke pemukiman memanjat pagar yang ada di belakang desa',
        nextDialogId: 'ending_l1',
        //TODO if kebanyakan salah uda gamuncul
        //TODO muncul cuma kalau interaksi ke pager (pas ke lock ataupun gak ke lock)
      },
      {
        text: 'Pembunuh langsung kembali ke desa, melewati pintu yang ada di belakang desa.',
        nextDialogId: 'ending_m1',
        ///TODO if kebanyakan salah uda gamuncul

      },
    ],
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "elsa_2",
  },
  ending_j1: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Saya bingung, jadi maksudnya apa?`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_j2",
  },
  ending_j2: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Aku juga bingung Yan...`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_i4",
  },
  ending_j3: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Kamu sepertinya hanya mengarang-ngarang.`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_i4",
  },
  ending_j4: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Yan, bisakah kamu lebih jelas?`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2b",
  },
  ending_k1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Itu tidak mungkin terjadi.`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_k2",
  },
  ending_k2: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Di waktu kematian Sondakh, saya di dermaga.`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_k3",
  },
  ending_k3: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Jika ada aktivitas di dekat dermaga, pasti saya tahu.`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_j3",
  },
  ending_l1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Tidak mungkin. Pagar yang mengelilingi pemukiman, setinggi 3 meter!`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_j3",
  },
  ending_l2: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Bagi manusia biasa, tidak mungkin, tapi bagi sebuah Songko...`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_l3",
  },
  ending_l3: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Seandainya ada bukti kuat yang bisa membuktikan hal itu..`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2c",
  },
  ending_m1: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Hanya ada satu pintu disitu, dan pintu itu selalu terkunci.`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2c",
  },
  ending_m2: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Aku juga sempat melewati tempat itu, tetapi pagar itu dikunci.`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_choice_2c",
  },
  ending_choice_2c: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      ...badEndingChoices,
      {
        text: 'Tunjukan Sobekan Kain',
        nextDialogId: 'ending_n1',
        //TODO muncul cuma kalau ada interaksi kain ditemukan
      },
      {
        text: 'Pelaku melompati pagar menuju ke pemukiman',
        nextDialogId: 'ending_na0',
      },
    ],
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_j3",
  },

  ending_na0: {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Pelaku berlari ke arah desa, dan melompati pagar.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_na2",
    bpm : 5,
  },
  ending_na1: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Tentu saja jika pelaku pembunuhan adalah Songko`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_na2",
    bpm : 5,
  },
  ending_na2: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Hal itu sangat mungkin terjadi`,
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_na3",
  },
  ending_na3: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Saya rasa bukti yang disampaikan Yan, masuk akal`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ending_n7",
  },

  ending_n1: {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Aku menemukan sesuatu di dekat pemukiman`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ending_n2",
    bpm : 5,
  },
  ending_n2: {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Sebuah kain yang robek dengan lumuran darah.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/gate.ktx2',
    nextDialogId : "ending_n3",
  },
  ending_n3: {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Jika kalian ingat, mayat Sondakh juga ditemukan dengan sebagian baju sobek`,
    backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.ktx2',
    nextDialogId : "ending_n4",
  },
  ending_n4: {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Dan tidak mungkin, Elsa berada di daerah situ saat kematian Sondakh, karena terlalu jauh.`,
    backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId : "ending_n4a",
  },
  ending_n4a: {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Mustahil... aku bisa mengkonfirmasi sobekan itu dari baju Sondakh`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ending_n5",
  },
  ending_n5: {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Luar biasa Yan! Penjelasan mu!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ending_n6",
  },
  ending_n6: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Saya rasa bukti yang disampaikan Yan, sudah cukup kuat`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ending_n7",
  },
  ending_n7: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Holga, ato, bagaimana menurut kalian?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ending_n8",
  },
  ending_n8: {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Berarti yang membunuh Sondakh, bukan Elsa...`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ending_n9",
  },
  ending_n9: {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Kerja yang baik Yan. Lalu, bagaimana menjelaskan tentang kematian Diana?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_1",
  },
}

let endingPart2: { [id: string]: DialogNode } = {
  ...holgaBlamedBadEnding,
  ...yanBlamedBadEnding,
  ...bungaBlamedBadEnding,
  ep2_1 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Betul... Di saat kematian Diana`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_2",
  },
  ep2_2 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Elsa satu kamar dengan Diana!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_3",
  },
  ep2_3 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Bagaimana kamu bisa menjelaskan itu?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_4",
  },
  ep2_4 : {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      {
        text: 'Mari kita dengar, alasan dari Elsa terlebih dahulu',
        nextDialogId: 'ep2_5',
      },
      {
        text: 'Elsa, bisa kita dengar cerita mu?',
        nextDialogId: 'ep2_5',
      },
      {
        text: 'Bukankah kamu juga disekitar situ Holga?',
        nextDialogId: 'bad_ending_holga_1',
        //TODO only if holga keliatan
      },
    ],
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_1",
  },
  ep2_5 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Tentu saja Yan`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_6",
  },
  ep2_6 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Pagi itu aku terbangun beberapa kali karena sakit.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_7",
  },
  ep2_7 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Beberapa kali aku ke toilet, mungkin 2-3x`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_8",
  },
  ep2_8 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Perutku sakit, sepertinya aku makan sesuatu yang tidak biasa aku makan.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_9",
  },
  ep2_9 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Saat aku kembali, untuk kesekian kalinya, Diana tiba2 sudah dalam keadaan meninggal.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_10",
  },
  ep2_10 : {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      {
        text: 'Apa kondisi Diana sebelum kamu pergi ke toilet untuk terakhir kalinya?',
        nextDialogId: 'ep2_b1',
      },
      {
        text: 'Apakah kamu menyadari sesuatu yang mencurigakan pagi itu?',
        nextDialogId: 'ep2_c1', //TODO hanya kalau holga diracunin
      },
      {
        text: 'Berapa lama kamu meninggalkan Diana sebelum bertemu dia meninggal?',
        nextDialogId: 'ep2_d0', //TODO kalau holga gak diracunin baru muncul? muncul gpp jg sih
      },
    ],
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId : "ep2_4",
  },
  ep2_b1 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Diana, baik-baik saja.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_d1",
  },
  ep2_c1 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Tidak ada...`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_c2",
  },
  ep2_c2 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Sebentar, sepertinya aku ingat ada yang mengetuk pintu WC dengan cukup keras`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_d1",
  },
  ep2_d0 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Hanya sekitar 15 menit`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_d1",
  },
  ep2_d1 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Apakah kita bisa mempercayai perkataanya?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_d2",
  },
  ep2_d2 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Aku rasa, dia ke toilet untuk membersihkan dirinya dari darah Diana!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_d3",
  },
  ep2_d3 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Itu masuk akal!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ep2_d4",
  },
  ep2_d4 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Tidak, Yan, pasti ada seseorang yang melihatku pagi itu!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_d5",
  },
  ep2_d5 : {
    id: 'ending_1',
    speaker: '',
    text: ``,
    choices: [
      {
        text: 'Romo Darius, apakah bisa memberi kesaksian pagi itu?',
        nextDialogId: 'ep2_e1',
      },
      {
        text: 'Bunga, apakah kamu menjelaskan skenario pagi itu?',
        nextDialogId: 'ep2_f1',
      },
      {
        text: 'Ato, apakah bisa melihat penjelasan pagi itu?',
        nextDialogId: 'ep2_g1',
      },
      {
        text: 'Holga, dimanakah kamu pagi itu? (Holga gak diracunin)',//TODO if lainnya
        nextDialogId: 'ep2_h1',
      },
      {
        text: 'Holga, dimanakah kamu pagi itu? (Holga diracunin)',//TODO if holga diracunin, dan keliatan sama kita
        nextDialogId: 'ep2_ha1',
      },
    ],
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId : "ep2_d1",
  },
  ep2_e1 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Pagi ini saya sedang didekat rumah mu Yan`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_e2",
  },
  ep2_e2 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Saya sedang pulang dari kuburan setelah mendoakan Sondakh`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_e3",
  },
  ep2_e3 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Saat melewati rumah kamu, saya melihat pergerakan didepan rumah kamu. `,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_e4",
  },
  ep2_e4 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Hanya saja sangat gelap jadi saya tidak tahu itu siapa.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_e5",
  },
  ep2_e5 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Itu pasti diriku!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_e6",
  },
  ep2_e6 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Romo, betulkah orang yang romo lihat berlari dari arah toilet?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_e7",
  },
  ep2_e7 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Saya tidak bisa sepenuhnya mengingat, tetapi kurang lebih sepertinya betul.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_e8",
  },
  ep2_e8 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Dengar kalian semua? Kesaksian Romo mengkonfirmasi cerita ku!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_e9",
  },
  ep2_e9 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Tetapi tetap saja! Kamu bisa melakukan apa saja di toilet!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_e10",
  },
  ep2_e10 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Bisa saja kamu sedang membersihkan diri dari bekas pembunuhan!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_i3",
  },

  ep2_f1 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Maaf Yan, pagi itu sangat pagi aku sudah sedang berendam di danau.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "ep2_f2",
  },
  ep2_f2 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Aku tidak melihat apa-apa terkait itu`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "ep2_f3",
  },
  ep2_f3 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Apakah normal untuk mandi sepagi itu?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_f4",
  },
  ep2_f4 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Jangan jangan, kamu pelakunya! Dan kamu membasuh diri di Danau untuk membersihkan darah Diana!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_f5",
  },
  ep2_f5 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Aku memang sering mandi di danau pagi-pagi`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "ep2_f6",
  },
  ep2_f6 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Mandi pagi sangat bagus untuk kulit.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "ep2_f7",
  },
  ep2_f7 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: 'Aku tidak bisa percaya.',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_f8",
  },
  ep2_f8 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Cukup Holga, aku bisa mendukung perkataan Bunga',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_f9",
  },
  ep2_f9 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Kita sering berpapasan di pagi hari',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_f10",
  },
  ep2_f10 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Yan, bagaimana pendapatmu?',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_f11",
  },
  ep2_f11 : {
    id: 'ending_1',
    speaker: '',
    text: '',
    choices : [
      {
        text: 'Aku tahu siapa yang pelakunya semua ini',
        nextDialogId: 'ep2_i8',
      },
      {
        text: 'Aku memiliki informasi cukup untuk mengetahui pembunuh Songko',
        nextDialogId: 'ep2_i8',
      },
    ],
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
  },

  ep2_g1 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Sejujurnya pagi itu saya belum bangun`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ep2_g2",
  },
  ep2_g2 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Aku tidak punya informasi apapun yang bisa membantu`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ep2_i1",
  },


  ep2_h1 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Pagi itu, aku masih dirumah.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_i1",
  },

  ep2_ha1 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Aku sedang di luar, tapi aku tidak melihat apapun`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_ha2",
  },
  ep2_ha2 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Apakah kamu bisa lebih spesifik Holga?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_ha3",
  },
  ep2_ha3 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Aku... `,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_ha4",
  },
  ep2_ha4 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Aku tadi pagi sempat ke toilet`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_ha5",
  },
  ep2_ha5 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Saat kembali dari toilet, aku melihat Elsa keluar dari rumah`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_ha6",
  },
  ep2_ha6 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Maka aku bersembunyi untuk mengintai Elsa, aku yakin pasti dia mempunyai niat buruk!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_ha7",
  },
  ep2_ha7 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Lalu aku mendengar suara yang kencang dari rumah Yan`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_ha8",
  },
  ep2_ha8 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Tidak lama kemudian, Elsa kembali dah menemukan Diana sudah tidak bernyawa.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_ha9",
  },
  ep2_ha9 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Tidak mungkin...`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ep2_ha10",
  },
  ep2_ha10 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: `Berarti Elsa bukan pembunuh Diana?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ep2_ha11",
  },
  ep2_ha11 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Yan, bagaimana pendapatmu?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_i7",
  },

  ep2_i1 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Sepertinya tidak ada orang yang menyaksikan aku pagi itu.`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_i2",
  },
  ep2_i2 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Tapi aku janji, bukan aku orangnya!`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_i3",
  },
  ep2_i3 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Kalau bukan kamu, siapa lagi yang bisa membunuh Diana?`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_i4",
  },
  ep2_i4 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Mungkin kamu bisa mengelak dari tuduhan pembunuhan Sondakh`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_i5",
  },
  ep2_i5 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Tapi tidak untuk Diana`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_i6",
  },
  ep2_i6 : {
    id: 'ending_1',
    speaker: '',
    text: 'Jika sudah tidak ada perlawanan, ayo tahan dia!',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId : "ep2_i7",
  },
  ep2_i7 : {
    id: 'ending_1',
    speaker: '',
    text: '',
    choices : [
      {
        text: 'Tenang semua, aku punya semua informasi untuk membuktikan siapa pembunuhnya.',
        nextDialogId: 'ep2_i8',
      },
      {
        text: 'Berikan aku kesempatan, aku tahu siapa pembunuhnya',
        nextDialogId: 'ep2_i8',
      },
    ],
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
  },
  ep2_i8 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Semua, ayo, kita dengarkan Yan. ',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_i9",
  },
  ep2_i9 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Yan, kamu akan menuduh seseorang untuk pembunuhan. ',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_i10",
  },
  ep2_i10 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Sebaiknya, kamu memiliki alasan yang sangat kuat.',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_i11",
  },
  ep2_i11 : {
    id: 'ending_1',
    speaker: '',
    text: 'Pembunuh Diana, Sondakh, dan wujud Songko asli, adalah',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    choices : [
      {
        text: 'Holga',
        nextDialogId: 'ep2_j1',//DONE
      },
      {
        text: 'Elsa',
        nextDialogId: 'ep2_k1',//DONE
      },
      {
        text: 'Bunga',
        nextDialogId: 'ep2_l1',//DONE
      },
      {
        text: 'Tidak ada pembunuh',
        nextDialogId: 'se_1',//TODO only appear if all clues are present and girl yan
      },
      {
        text: 'Nenek (Good Karma)',
        nextDialogId: 'ge_1',//TODO only appear if... rosario/sobekan ketemu, panada holga, good karma
      },
      {
        text: 'Nenek (Bad Karma)',
        nextDialogId: 'be_1',//TODO only appear if... karma jelek
      },
    ],
  },

  be_1 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: 'Yan... tega-teganya',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "be_2",
  },
  be_2 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: 'Kamu menuduh nenekmu sendiri! Aku tidak percaya!',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "eps2_jc3",
  },

  ep2_l1 : {
    id: 'ending_1',
    speaker: 'Yan',
    text: 'Maafkan aku Bunga, berdasarkan bukti yang aku punya, kamu adalah pembunuh Diana.',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId : "ep2_l2",
  },
  ep2_l2 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: 'Yan! Tega-teganya kamu menuduh aku!',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "ep2_l3",
  },
  ep2_l3 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Yan, kamu pasti punya alasan yang sangat kuat untuk tuduhan ini?',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_l4",
  },
  ep2_l4 : {
    id: 'ending_1',
    speaker: '',
    text: '',
    choices: [
      {
        text: 'Setiap kali ada kematian, keberadaan Bunga selalu mencurigakan',
        nextDialogId: 'ep2_la1',
      },
      {
        text: 'Bunga iri kepada Sondakh dan Diana!',
        nextDialogId: 'ep2_lb1',
      },
      {
        text: 'Bunga cemburu kepada Elsa, dan menmfitnah Elsa',
        nextDialogId: 'ep2_lc1',
      },
    ],
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_l3",
  },

  ep2_la1 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Benarkah itu?',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_la2",
  },
  ep2_la2 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: 'Saya mendengar rumor, saat kematian Sondakh',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ep2_la3",
  },
  ep2_la3 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: 'Bunga juga ada di danau?',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "ep2_la4",
  },
  ep2_la4 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: 'Itu betul, aku dan diana meninggalkan Bunga di pinggir danau, tidak lama kemudian kami menemukan Sondakh.',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/elsa.png',
    nextDialogId : "ep2_la5",
  },
  ep2_la5 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: 'Pastinya kamu yang membunuh Sondakh! Teganya kamu!',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "ep2_la6",
  },
  ep2_la6 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: 'Tunggu dulu semua!',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "ep2_la7",
  },
  ep2_la7 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: 'Yan! Kita kan sahabat, bantu aku',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/bunga.png',
    nextDialogId : "ep2_la8",
  },
  ep2_la8 : {
    id: 'ending_1',
    speaker: '',
    text: '',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    choices: [
      {
        text: 'Bunga, sudah cukup. Kecantikanmu tidak bisa menggodaku.',
        nextDialogId: 'ep2_la9',
      },
      {
        text: 'Bunga, kamu harus bertanggung jawab untuk kematian Diana!',
        nextDialogId: 'ep2_la9',
      },
    ],
  },
  ep2_la9 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: 'Darah, harus dibalas oleh darah!',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/holga.png',
    nextDialogId : "bad_ending_bunga_1",
  },


  ep2_k1 : {
    id: 'ending_1',
    speaker: 'Yan',
    text: 'Maafkan aku Elsa. Aku telah berusaha terbaik untuk membela mu',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId : "ep2_k2",
  },
  ep2_k2 : {
    id: 'ending_1',
    speaker: 'Yan',
    text: 'Tapi semua petunjuk mengerah ke kamu. Hanya kamu yang bisa membunuh Diana.',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId : "ep2_k3",
  },
  ep2_k3 : {
    id: 'ending_1',
    speaker: 'Ato',
    text: 'Aku bingung, kamu di sisi siapa sebetulnya?',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/ato.png',
    nextDialogId : "yanBlamedBadEnding_1",
  },
  ep2_j1 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: 'Holga?',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/darius.png',
    nextDialogId : "ep2_j2",
  },
  ep2_j2 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Apa alasan kamu menuduh Holga?',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ep2_j3",
  },
  ep2_j3 : {
    id: 'ending_1',
    speaker: '',
    text: '',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    choices : [
      {
        text: 'Motifnya sudah jelas. Balas Dendam',
        nextDialogId: 'eps2_ja1',
      },
      {
        text: 'Holga agresif menyalahkan orang lain untuk menutupi perbuatannya',
        nextDialogId: 'eps2_jb1',
      },
    ],
  },
  eps2_ja1 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Motifnya sudah jelas. Balam dendam.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ja2",
  },
  eps2_ja2 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Holga resah karena kehadiran Elsa dari kota.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ja3",
  },
  eps2_ja3 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Kecantikan Elsa dinilai lebih cantik dari Sondakh, maka diapun kesal dan membunuh Diana.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ja4",
  },
  eps2_ja4 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Dengan itu Elsa disalahkan untuk kematian Diana.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ja6",
  },
  eps2_ja6 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Penjelasanmu tidak masuk akal!',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ja7",
  },
  eps2_ja7 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Lalu kenapa aku membunuh anakku sendiri?',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ja8",
  },
  eps2_ja8 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Benar Yan, apa alasan holga membunuh anaknya sendiri?',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ja9",
  },
  eps2_ja9 : {
    id: 'ending_1',
    speaker : "Apa alasan Holga membunuh Sondakh?",
    text: '',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    choices : [
      {
        text: 'Sondakh mati dalam sebuah kecelakaan',
        nextDialogId: 'eps2_ka1',
      },
      {
        text: 'Karena Holga adalah Songko!',
        nextDialogId: 'eps2_kb2',
      },
    ],
  },
  eps2_ka1 : {
    id: 'ending_1',
    speaker : "Ato",
    text: 'Mana mungkin Sondakh mati karena kecelakaan?',
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_ka2",
  },
  eps2_ka2 : {
    id: 'ending_1',
    speaker : "Ato",
    text: 'Kamu tidak melihat kondisi mayatnya?',
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_jc3",
  },

  eps2_kb1 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Tuduhanmu tidak masuk akal!',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_kb2",
  },
  eps2_kb2 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Tadi aku dituduh membalas dendam',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_kb3",
  },
  eps2_kb3 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Sekarang aku menjadi Songko?',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_jc3",
  },

  eps2_jb1 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Perbuatan apa yang kamu maksud Yan?',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_jb2",
  },
  eps2_jb2 : {
    id: 'ending_1',
    speaker : "",
    text: '',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    choices: [
      {
        text: 'Mencuri barang dari gereja.',
        nextDialogId: 'eps2_jc3',
      },
      {
        text: 'Membunuh Sondakh! Karena dia Songko!',
        nextDialogId: 'eps2_jd1',
      },
    ],
  },
  eps2_jc3 : {
    id: 'ending_1',
    speaker : "Ato",
    text: 'Sepertinya kamu hanya mengarang-ngarang',
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "yanBlamedBadEnding_1",
  },
  eps2_jd1 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Holga pasti membunuh Sondakh karena dia adalah Songko!',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_jd2",
  },
  eps2_jd2 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Dia membunuh anaknya sendiri agar tetap muda!',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_jd3",
  },
  eps2_jd3 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Lalu agar semua menyalahkan Elsa, dia membunuh Diana yang terus bersama Elsa.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "eps2_jd4",
  },
  eps2_jd4 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Agar Elsa yang dituduh oleh semua orang lain.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "bad_ending_holga_a1",
  },

  ge_1 : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Nenek adalah pembunuh Sondakh dan Diana',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_2",
  },
  ge_2 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Kamu menuduh nenekmu sendiri?',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_3",
  },
  ge_3 : {
    id: 'ending_1',
    speaker : "",
    text: 'Betul Romo, aku memiliki alasan yang kuat.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_4",
  },
  ge_4 : {
    id: 'ending_1',
    speaker : "",
    text: '',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    choices : [
      {
        text: 'Aku menemukan patahan Rosario ini',
        nextDialogId: 'ge_5a',//TODO only kalau ada rosario
      },
      {
        text: 'Aku menemukan sobekan baju di dekat pagar',
        nextDialogId: 'ge_5b',
      },
    ],
  },
  ge_5a : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Aku menemukan patahan Rosario ini bersama sobekan baju ini!',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_6",
  },
  ge_5b : {
    id: 'ending_1',
    speaker : "Yan",
    text: 'Aku menemukan sobekan baju ini bersama dengan rosario ini!',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_6",
  },
  ge_6 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Aku mengenal rosario itu...',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_7",
  },
  ge_7 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Memang seperti milik nenek mu!',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_8",
  },
  ge_8 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Dan sobekan baju itu..',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_9",
  },
  ge_9 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Memang sama seperti baju Sondakh',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_10",
  },
  ge_10 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Sepertinya masuk akal, tetapi saya merasa alasan tersebut belum cukup konkrit',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_11",
  },
  ge_11 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Apakah kamu punya alasan pendukung?',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_12",
  },
  ge_12 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Seperti cara nenek membunuh Diana?',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_13",
  },
  ge_13 : {
    id: 'ending_1',
    speaker : "",
    text: '',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    choices : [
      {
        text: 'Nenek meracuni Elsa agar Elsa lengah',
        nextDialogId: 'ge_14',
      },
      {
        text: 'Nenek membunuh Diana saat Elsa sedang tidur',
        nextDialogId: 'ge_a1',
      },
    ],
  },

  ge_a1 : {
    id: 'ending_1',
    speaker : "Elsa",
    text: 'Maaf yan aku tahu itu tidak benar',
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_a2",
  },
  ge_a2 : {
    id: 'ending_1',
    speaker : "Elsa",
    text: 'Saat aku bangun, Diana masih hidup',
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_a3",
  },
  ge_a3 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Aku awalnya mulai mempercayai kamu',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_a4",
  },
  ge_a4 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Tapi kamu kedengarannya sedang mengarang-ngarang',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "yanBlamedBadEnding_1",
  },

  ge_14 : {
    id: 'ending_1',
    speaker : "Elsa",
    text: 'Aku diracuni?',
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_15",
  },
  ge_15 : {
    id: 'ending_1',
    speaker : "Elsa",
    text: 'Apakah karena itu aku sakit perut?',
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_16",
  },
  ge_16 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Bagaimana cara nenek bisa meracuni Elsa?',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_17",
  },
  ge_17 : {
    id: 'ending_1',
    speaker : "Elsa",
    text: 'Apakah dari minuman atau makanan yang diberikan nenek kepadaku?',
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_18",
  },
  ge_18 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Pasti Panada itu!',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_19",
  },
  ge_19 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Aku juga dibuat sakit perut karena panada nenek mu!',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_20",
  },
  ge_20 : {
    id: 'ending_1',
    speaker : "Elsa",
    text: 'Berarti tadi pagi, yang mengetuk di toilet tadi pagi...',
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_21",
  },
  ge_21 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Betul. Sebetulnya aku sedang mengantre di toilet.',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_22",
  },
  ge_22 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Aku tidak mau mengakuinya karena takut ikut dituduh membunuh Diana',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_23",
  },
  ge_23 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Maafkan aku anak muda.',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_24",
  },
  ge_24 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Aku masih tidak bisa percaya, aku mengenal nenekmu lama',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_25",
  },
  ge_25 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Dengan kondisi badannya yang sakit bagaimana dia bisa membunuh Sondakh dan Diana?',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_26",
  },
  ge_26 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Sepertinya sudah satu tahun nenek hanya berbaring di kamarnya...',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_27",
  },
  ge_27 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Sampai beberapa hari lalu dia menjadi lebih sehat dan bisa bergerak.',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_28",
  },
  ge_28 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Jangan-jangan, alasan dia bisa bergerak',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_29",
  },
  ge_29 : {
    id: 'ending_1',
    speaker : "Holga",
    text: 'Setelah membunuh Sondakh, nenekmu menjadi lebih sehat',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_30",
  },
  ge_30 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Yan... nenekmu seorang Songko!',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_31",
  },
  ge_31 : {
    id: 'ending_1',
    speaker : "Bunga",
    text: 'Dia membunuh Diana untuk menyerap kekuatanya dan hidup abadi!',
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_32",
  },
  ge_32 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Berarti.. nenekmu menyerang Sondakh saat dia sedang sendiri',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/cutscene/songko_v_sondakh.ktx2',
    nextDialogId : "ge_33",
  },
  ge_33 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Terlepas perlawanannya, Sondakh tetap dibunuh...',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/cutscene/songko_v_sondakh.ktx2',
    nextDialogId : "ge_34",
  },
  ge_34 : {
    id: 'ending_1',
    speaker : "Ato",
    text: 'Dan dia membunuh Diana saat Elsa sedang lengah',
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/cutscene/songko_v_diana.ktx2',
    nextDialogId : "ge_35",
  },
  ge_35 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Yan, sepertinya kamu berhasil memecahkan kasus ini.',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_36",
  },
  ge_36 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Ato, demi keamanan desa, kita harus segera bertindak',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_37",
  },
  ge_37 : {
    id: 'ending_1',
    speaker : "Romo Darius",
    text: 'Tetapi kita harus berhati-hati, kita tidak tahu kekuatan penuh dari Songko',
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_38",
  },
  ge_38 : {
    id: 'ending_1',
    speaker : "Ato",
    text: 'Romo, aku yakin, semua orang di desa tidak sabar untuk menyelesaikan ini',
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_39",
  },
  ge_39: {
    id: 'ending_1',
    speaker: '',
    text: `Ayo! Kita Maju!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "ge_40",
  },
  ge_40 : {
    id: 'ending_1',
    speaker : "Ato",
    text: 'Romo, aku yakin, semua orang di desa tidak sabar untuk menyelesaikan ini',
    characterImage: '/assets/character/v2/ato.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "ge_41",
  },
  ge_41: {
    id: 'ending_1',
    speaker: '',
    text: `Ayo kita tangkap nenek! Ayo cari dia!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "ge_42",
  }, 
  ge_42: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    nextDialogId: "ge_43",
    fade : true,
    autoplay : 2,
  },
  ge_43: {
    id: 'ending_1',
    speaker: '',
    text: `Itu dia! Ayo tangkap!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "ge_44",
    fade : true,
  },
  ge_44: {
    id: 'ending_1',
    speaker: 'Nenek',
    text: `Ada apa ini... pagi-pagi sudah ribut sekali`,
    backgroundImage: '/assets/backdrop/desa.ktx2',
    characterImage: '/assets/character/v2/nenek.png',
    nextDialogId: "ge_45",
  },
  ge_45: {
    id: 'ending_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    nextDialogId: "good_1",
    fade : true,
    autoplay : 2,
  },

  se_1 : {
    id: 'se_1',
    speaker : "Yan",
    text: 'Tidak ada.. aku tidak bisa menemukan pembunuhnya',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "se_2",
  },
  se_2 : {
    id: 'se_1',
    speaker : "Yan",
    text: 'Karena semua orang disini tidak mungkin bersalah dan mempunyai alibi!',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "se_3",
  },
  se_3 : {
    id: 'se_1',
    speaker : "Holga",
    text: 'Tidak mungkin! Pasti temanmu itu yang membunuh mereka!',
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/backdrop/desa.ktx2',
    nextDialogId : "se_4",
  },
  se_4 : {
    id: 'ending_1',
    speaker: '',
    text: `Sudah cukup! Saatnya kita membalas dendam!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_5",
  },
  se_5 : {
    id: 'ending_1',
    speaker: 'Romo Darius',
    text: `Semuanya harap tenang!! Kita harus bisa mengedalikan diri!`,
    characterImage: '/assets/character/v2/darius.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_6",
  },
  se_6 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Yan tolong aku!!`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_7",
  },
  se_7 : {
    id: 'ending_1',
    speaker: '',
    text: ``,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    choices : [
      {
        text: '[Selamatkan Elsa]',
        nextDialogId: 'bad_ending_elsa_a13',
      },
      {
        text: '[Korbankan diri]',
        nextDialogId: 'se_8',
      },
    ],
  },
  se_8 : {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Cukup! Berhenti!`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_9",
  },
  se_9 : {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Aku yang membunuh Diana! Aku yang membunuh Sondakh!`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_10",
  },
  se_10 : {
    id: 'ending_1',
    speaker: 'Yan',
    text: `Lepaskan Elsa!!`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_11",
  },
  se_11 : {
    id: 'ending_1',
    speaker: 'Holga',
    text: `Jika memang begitu, kamu yang harus mati!`,
    characterImage: '/assets/character/v2/holga.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_12",
  },
  se_12 : {
    id: 'ending_1',
    speaker: '',
    text: `Tangkap dia!!!`,
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_13",
  },
  se_13 : {
    id: 'ending_1',
    speaker: 'Bunga',
    text: `Yan!!!`,
    characterImage: '/assets/character/v2/bunga.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "se_14",
  },
  se_14 : {
    id: 'ending_1',
    speaker: 'Elsa',
    text: `Yan!!!`,
    characterImage: '/assets/character/v2/elsa.png',
    backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
    nextDialogId: "secret_1",
  },

}

const config: { [id: string]: DialogNode } = {
  ...endingPart1,
  ...endingPart2,
  ...V2EndingNodes.SECRET_ENDING,
  ...V2EndingNodes.GAME_OVER_ENDING,
  ...V2EndingNodes.GOOD_ENDING,
}

export default config
